export const BX_DESKTOP_MAIN_PAGE = 'aud_desktop_bx206_search_string_desktop';
export const AUD_MOBILE_REDESIGN_MAINPAGE_HEADER = 'aud_mobile_bx925_redesign_mainpage_header';

export const EXPERIMENTS: string[] = [BX_DESKTOP_MAIN_PAGE, AUD_MOBILE_REDESIGN_MAINPAGE_HEADER];
